import { Component, inject, signal } from '@angular/core';
import { BundleDetailsComponent } from '../../../../../components/admin-dashboard-component/promotions/bundles-managment/bundle-details-component/bundle-details-component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-bundle-details',
  imports: [BundleDetailsComponent],
  templateUrl: './bundle-details.html',
  styleUrl: './bundle-details.scss',
})
export class BundleDetails {
  private route = inject(ActivatedRoute);
  selectedBundleId = signal<string>('0');
  ngOnInit() {
    console.log('bundle details init');
    const bundleId = this.route.snapshot.params['id'];
    console.log(bundleId);
    if (bundleId) {
      this.selectedBundleId.set(bundleId);
    }
  }
}
